import type { RedoCustomerWidgetRpcClient } from "@redotech/chat-widget-sdk/customer-widget-rpc/client";
import { Context, createContext } from "react";

export const RedoCustomerWidgetRpcClientContext: Context<
  RedoCustomerWidgetRpcClient | undefined
> = createContext<RedoCustomerWidgetRpcClient | undefined>(undefined);
RedoCustomerWidgetRpcClientContext.displayName =
  "RedoCustomerWidgetRpcClientContext";
